import { container } from "tsyringe";
import CastApi from "api/clapaction/projects/[id]/config/team/[projectTeamId]/CastApi";
import ProjectTeamCastRequestResource from "common/resources/Project/Config/Team/Cast/ProjectTeamCastRequestResource";
import ProjectTeamCastResponseResource from "common/resources/Project/Config/Team/Cast/ProjectTeamCastResponseResource";
import toValidationError from "utils/toValidationError";

export default class CastService {
	private api: CastApi = container.resolve(CastApi);

	/**
	 * @description Get all by project team id
	 */
	public async getAllByProjectTeamId(projectId: string, projectTeamId: string): Promise<ProjectTeamCastResponseResource[]> {
		return this.api.getAllByProjectTeamId(projectId, projectTeamId).catch(toValidationError);
	}

	/**
	 * @description Get one by id
	 */
	public async getById(projectId: string, projectTeamId: string, castId: string): Promise<ProjectTeamCastResponseResource> {
		return this.api.getById(projectId, projectTeamId, castId).catch(toValidationError);
	}

	/**
	 * @description Download cast image
	 */
	public async downloadImage(projectId: string, projectTeamId: string, castId: string): Promise<Blob | null> {
		return this.api.downloadImage(projectId, projectTeamId, castId).catch(() => null);
	}

	/**
	 * @description Create a new cast for a project team
	 */
	public async create(projectId: string, projectTeamId: string, request: ProjectTeamCastRequestResource, image?: File): Promise<ProjectTeamCastResponseResource> {
		return this.api.create(projectId, projectTeamId, request, image).catch(toValidationError);
	}

	/**
	 * @description Update a cast for a project team
	 */
	public async update(projectId: string, projectTeamId: string, castId: string, request: ProjectTeamCastRequestResource, image?: File): Promise<ProjectTeamCastResponseResource> {
		return this.api.update(projectId, projectTeamId, castId, request, image).catch(toValidationError);
	}

	/**
	 * @description Delete a cast for a project team
	 */
	public async delete(projectId: string, projectTeamId: string, castId: string): Promise<void> {
		return this.api.delete(projectId, projectTeamId, castId).catch(toValidationError);
	}
}
